import * as React from "react";
import { ChevronRight, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const CRUMB_LABEL_CLASS = "inline-block min-w-0 max-w-full align-bottom break-words";

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  if (!items || !Array.isArray(items)) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        "flex w-full min-w-0 flex-wrap items-center justify-end gap-x-2 gap-y-1",
        className
      )}
    >
      <Link
        to="/dashboard"
        className="flex items-center shrink-0 text-[#495057] hover:text-primary transition-colors"
        aria-label="Home"
      >
        <Home className="h-4 w-4" />
      </Link>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${index}`}>
            <ChevronRight className="h-4 w-4 shrink-0 text-[#495057] opacity-50" />
            {item.href && !isCurrent ? (
              <Link
                to={item.href}
                className={cn(
                  "text-sm text-[#495057] transition-colors hover:text-primary",
                  CRUMB_LABEL_CLASS
                )}
                title={item.label}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={cn("text-sm font-medium text-[#495057]", CRUMB_LABEL_CLASS)}
                title={item.label}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
